import { render, staticRenderFns } from "./SharedManuscriptPage.vue?vue&type=template&id=4256be96&scoped=true&"
import script from "./SharedManuscriptPage.vue?vue&type=script&lang=ts&"
export * from "./SharedManuscriptPage.vue?vue&type=script&lang=ts&"
import style0 from "./SharedManuscriptPage.vue?vue&type=style&index=0&id=4256be96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4256be96",
  null
  
)

export default component.exports